<template>
  <div class="container-fluid">

    <div class="row is-loading" v-if="isLoading">
      Cargando....
    </div>

    <div class="sheet" v-else>
      <risk-credit-header />
    </div> <!-- .sheet -->
  </div>

</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import RiskCreditHeader from "@views/admin/RiskModel/Dashboard/RiskCreditHeader";
import CirculoCreditoScoreDashboard from "@components/credit-model/ci-score/circulo-credito-score-dashboard";
import ApproveModelRiskV2 from "@views/admin/RiskModel/Dashboard/RiskModel/ApproveModelRiskV2";
import ProjectRequestTab from "@projects/ProjectRequestTab";
import TabEconomy from "@views/admin/projects/process-flow/tab-economy";
import PreApproveRiskModelV2 from "@views/admin/RiskModel/Dashboard/RiskModel/PreApproveRiskModelV2";
import ArcTabV2 from "@views/admin/projects/process-flow/ArcTabV2";
import SupplierRiskModelProfileVerification
  from "@views/admin/RiskModel/Dashboard/RiskModel/SupplierRiskModel/ProfileVerification/SupplierRiskModelProfileVerification";
import ProfileVerificationResume
  from "@views/admin/RiskModel/Dashboard/RiskModel/SupplierRiskModel/ProfileVerificationResume/ProfileVerificationResume";
import BusinessProfileCdcModule from "../../Score/BusinessProfileCdcModule";
import PersonalProfileCdcModule from "../../Score/PersonalProfileCdcModule";
import RiskFactor from "../../risk-factors/RiskFactor.vue";
import ProjectPublicationTab from "../../../../components/projectsv2/ProjectPublicationTab.vue";
import ProjectHeader from "@components/project-details/ProjectHeader.vue";

export default {
  name: "Index",
  components: {
    ProjectHeader,
    ProjectPublicationTab,
    RiskFactor,
    PersonalProfileCdcModule,
    BusinessProfileCdcModule,
    ProfileVerificationResume,
    SupplierRiskModelProfileVerification,
    ArcTabV2,
    PreApproveRiskModelV2,
    TabEconomy,
    ProjectRequestTab,
    ApproveModelRiskV2,
    CirculoCreditoScoreDashboard,
    RiskCreditHeader
  },
  data: () => ({
    activeTab: 0,
    isLoading: false,
    currentSupplierId: null
  }),
  computed: {
    ...mapState('projects', ['project']),
  },
  async mounted() {
    let projectId = this.$route.params.id;
    this.isLoading = true;

    try {
      let project = await this.getProject({
        id: projectId,
        rel: [
          'client',
          'supplier',
          'splits',
          'finance',
          'contracts'
        ]
      })

      this.setProject(project);
      this.currentSupplierId = project.supplier_id
    } finally {
      this.isLoading = false;
    }

  },
  methods: {
    ...mapActions('projects', ['getProject']),
    ...mapMutations('projects', ['setProject']),
  }
}
</script>

<style scoped>

</style>
